import { companySettingsMapper } from '@dispatch/shared';
import { Company } from '@dispatch/shared/types';
import { Form, RenderFuncProps, TextField } from '@dispatch/web/ui';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
} from '@mui/material';
import { useEffect, useMemo } from 'react';
import { Control, FieldValues, useForm } from 'react-hook-form';

export const CompanySettingsAdmin = ({
  company,
  isLoading,
  handleCompanySettingsSave,
  companyUpsertStatus,
}: {
  company?: Company;
  isLoading?: boolean;
  handleCompanySettingsSave: (data: Record<string, string>) => void;
  companyUpsertStatus: 'success' | 'error' | 'loading' | 'idle';
}) => {
  const { control, formState, handleSubmit, reset } = useForm();

  const companyFormData = useMemo(() => {
    return {
      ...company?.settings,
    };
  }, [company?.settings]);

  useEffect(() => {
    reset(companyFormData);
  }, [companyFormData, reset]);

  const handleOnCompanySettingsSave = () => {
    handleSubmit(handleCompanySettingsSave)();
  };

  const renderHelper = (control: Control<FieldValues, any>, errors: any) => {
    if (isLoading) {
      return <CircularProgress />;
    }

    return Object.keys(company?.settings || {}).map((key) => {
      return (
        <Grid item xs={4}>
          <TextField
            id={key}
            name={key}
            label={companySettingsMapper(key)}
            control={control}
            errors={errors}
          />
        </Grid>
      );
    });
  };

  return (
    <Card>
      <CardHeader
        title="Company Settings"
        sx={{
          '.MuiCardHeader-title': {
            fontSize: '18px',
          },
        }}
      />
      <CardContent>
        <Form
          control={control}
          handleSubmit={handleSubmit}
          errors={formState.errors}
          render={({ control, errors }: RenderFuncProps) => {
            return (
              <div style={{ width: '100%' }}>
                <Grid container spacing={2}>
                  {renderHelper(control, errors)}
                </Grid>
              </div>
            );
          }}
        />
      </CardContent>
      <CardActions
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          onClick={handleOnCompanySettingsSave}
          variant="contained"
          disabled={!formState.isDirty || companyUpsertStatus === 'loading'}
        >
          Save
        </Button>
      </CardActions>
    </Card>
  );
};
